import { Grid, Card, CardContent, Chip, Box, Divider, Typography } from '@mui/material';
import DashboardOrdersExportButton from '../components/DashboardOrdersExportButton';

const cardStyle = { minWidth: "100%" };

const AcumuladoCard = ({
    dateRange, dateLabel, icon, totalSales, exportRange, exportFilename
}) => {
    const { total, qty } = totalSales;

    return (
        <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
            <Card style={cardStyle}>
                <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        <Box sx={{ my: 'auto' }}>
                            <i className={icon} style={{ fontSize: '1.5rem' }}></i>
                        </Box>

                        <Box sx={{ my: 'auto' }}>
                            <Chip className="font-weight-bold"
                                color="primary"
                                label={dateLabel}
                                size="small"
                                sx={{ borderRadius: '6px', p: 1 }}
                            />
                        </Box>
                    </Box>
                    <Typography variant='body1' sx={{ mt: 1 }}>
                        {dateRange}
                    </Typography>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', mt: 2.5 }}>
                        Pedidos: {qty}
                    </Typography>
                    <Divider sx={{ my: 3 }} />
                    <Typography variant='h6' sx={{ fontStyle: 'italic' }}>
                        Venta total: ${ total }
                    </Typography>
                    {exportRange && (
                        <Box sx={{ mt: 2, textAlign: 'right' }}>
                            <DashboardOrdersExportButton
                                reportType="sales"
                                range={exportRange}
                                filename={exportFilename}
                            />
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
};

export default AcumuladoCard;
